import ConfigUtil from "core/util/config/ConfigUtil";
import Logger from 'core/util/Logger';
import { iDef } from "core/util/TypeUtils";
import UrlUtil from "core/util/UrlUtil";
import ILocalCacheService from "../../service/cache/ILocalCacheService";
import { currentMode } from "../Mode";
import ServiceRegistry from "../ServiceRegistry";
import moment from "moment";

declare var window: any;

export default abstract class AbstractTokenSession {
	protected static TOKEN_PARAM: string = "token";
	protected static STORAGE_KEY: string = "auth";
	protected static PATH_PARAM: string = "path";

	protected token: string;
	protected active: boolean;
	protected established: number;

	constructor(token?: string) {
		this.active = this.init(token);
		this.established = Date.now();
	}

	protected saveToken(token: string, cacheService: ILocalCacheService): boolean {
		this.setToken(token);
		return cacheService.putString(AbstractTokenSession.STORAGE_KEY, token);
	}

	protected setToken(token: string) {
		this.token = token;
	}

	public getToken(): string {
		return this.token;
	}

	public isActive(): boolean {
		return this.active && typeof this.token === "string";
	}

	protected init(token?: string): boolean {
		const cacheService = ServiceRegistry.get(ILocalCacheService);

		// new token passed as param
		if(iDef(token) && this.checkTokenExpire(token)) {

			Logger.debug("Setting token in local storage");

			// save the token in local storage
			return this.saveToken(token, cacheService);
		}

		/// get the token from query string
		token = UrlUtil.getSearchParam(AbstractTokenSession.TOKEN_PARAM);

		if(iDef(token) && this.checkTokenExpire(token)) {

			Logger.debug("Setting token in local storage");

			// save the token in local storeage
			return this.saveToken(token, cacheService);
		}

		// get the token from local storage

		token = cacheService.getString(AbstractTokenSession.STORAGE_KEY);

		if(iDef(token) && this.checkTokenExpire(token))  {

			Logger.debug("Using token from local storage");

			// set the token we retrived from local storage
			this.setToken(token);

			return true;
		}

		// no token passed and not in local storage, redirect to lms gateway
		Logger.error("No token found in query string or local storage");
		// AbstractTokenSession.refresh();

		return false;
	}

	private checkTokenExpire(token) {
		let isvalid = false;
		try{
			if (token && typeof token === "string") {
				const decodedToken = JSON.parse(atob(token.split('.')[1]));
				const expireTime = moment.unix(decodedToken.exp);
				// Check if the future time is after the current time
				isvalid = expireTime.isAfter(moment());
			}
		} catch{
			return false;
		}
		return isvalid;
	}

	public static refresh() {
		if(currentMode.isDev()) {
			AbstractTokenSession.tokenPrompt();
		} else {
			window.location.replace(UrlUtil.getGatewayRedirectLink(
				UrlUtil.getCurrentPath(true).slice(1),
				UrlUtil.getCurrentParams()
			));
			// window.location.replace(ConfigUtil.getEnvConfig().gatewayUri);
		}
	}

	public static logout() {
		const cacheService = ServiceRegistry.get(ILocalCacheService);

		// remove the token from local storage
		cacheService.remove(AbstractTokenSession.STORAGE_KEY);

		// redirect to lms gateway if in prod mode
		if(currentMode.isDev()) {
			AbstractTokenSession.tokenPrompt();
		} else {
			window.location.replace(ConfigUtil.getEnvConfig().logoutUri);
		}

	}

	private static tokenPrompt() {
		if(iDef(window.DEV_TOOLS)) {
			window.DEV_TOOLS.promptLogin();
		} else {
			document.write("Token expired, please generate a new one.");
		}
	}
}



// WEBPACK FOOTER //
// ./src/core/util/session/AbstractTokenSession.ts